<template>
  <div>
    <b-modal
      size="lg"
      id="modalVincular"
      title="Vincular Usuário"
      centered
      no-close-on-backdrop
      cancel-title="Cancelar"
      hide-footer
    >
      <table
        class="table b-table b-table-stacked-md table-bordered bg-white table-sm"
        v-if="usuario"
      >
        <tbody>
          <tr>
            <td colspan="2">
              Nome do Usuário: <b>{{ usuario.nome_completo }}</b>
            </td>
            <td colspan="2">
              Filiação 1: <b>{{ usuario.mae }}</b>
            </td>
          </tr>
          <tr>
            <td>
              CPF: <b>{{ usuario.documento.cpf }}</b>
            </td>
            <td>
              NIS: <b>{{ usuario.documento.nis }}</b>
            </td>
            <td>
              Cor/Raça:
              <b v-for="cor_raca in $root.arrays.cor_raca" :key="cor_raca.id">
                <span v-if="cor_raca.id == usuario.cor_raca">{{
                  cor_raca.value
                }}</span>
              </b>
            </td>
            <td>
              Sexo: <b v-if="usuario.sexo == 1">Masculino</b>
              <b v-if="usuario.sexo == 2">Feminino</b>
              <b v-else>Intersexo</b>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              Família:
              <strong>
                <span v-if="usuario.codigo_familiar">
                  Código Cadúnico:
                  {{ usuario.codigo_familiar }}
                </span>
                <span v-else>ID{{ usuario.familia_id }}</span>
              </strong>
            </td>
            <td colspan="2">
              Responsável Familiar:
              <b>{{ usuario.familia.responsavel_familiar.nome_completo }}</b>
            </td>
          </tr>
        </tbody>
      </table>
      <form @submit.prevent="submitVinculo" ref="submitVinculo">
        <div class="row">
          <form-select
            v-model="item.situacao_prioritaria"
            grid="12"
            label="Selecione uma Situação Prioritária"
            :itens="situacoes_prioritarias"
            :required="true"
            ajuda="Essa situação precisa do parecer técnico e o mesmo deve ser inserido em até 30 dias após a inserção do usuário no serviço."
            :multiple="true"
            @change="situacaoPrioritariaSelecionada"
          />

          <form-input
            v-if="campoExtra"
            v-model="item.outra_situacao"
            grid="12"
            label="Digite a outra Situação Prioritária"
            :required="true"
          />
        </div>
        <div class="row pt-4 px-0 d-flex justify-content-end">
          <div class="col-auto px-2 text-right">
            <button
              class="btn btn-success btn-submit"
              data-style="zoom-in"
              type="submit"
            >
              <i class="mdi mdi-content-save" />
              {{ $t("Salvar") }}
            </button>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>
export default {
  props: ["usuario"],
  name: "ModalAddVinculo",
  data() {
    return {
      item: {
        usuario_id: null,
        scfv_grupo_id: null,
      },
      campoExtra: false,
      situacoes_prioritarias: [],
      situacao_outros_indice: null,
    };
  },
  mounted() {
    this.getItensSituacoesPrioritarias();
  },
  methods: {
    situacaoPrioritariaSelecionada(value) {
      const idOutro = this.situacoes_prioritarias.find(situacao => situacao.value === "OUTRAS")?.id;

      this.campoExtra = value.includes(idOutro);
    },
    submitVinculo() {
      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();
      this.item.usuario_id = this.usuario.id;
      this.item.scfv_grupo_id = this.$route.params.id;
      axios
        .post(`api/dashboard/scfvvinculo`, this.item)
        .then((response) => {
          ladda.stop();
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
        })
        .finally(() => {
          this.$bvModal.hide("modalVincular");
          this.$root.$emit("usuariosvinculado");
        });
    },
    getItensSituacoesPrioritarias() {
      axios
      .get(`api/dashboard/situacoes_prioritarias_ativas`)
      .then((response) => {
        this.situacoes_prioritarias = response.data.map((elem) => ({
          id: elem.id,
          value: elem.descricao,
        }));
      })
    }
  },
};
</script>
